var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"project-ad-budget-create","title":"Budget hinzufügen","width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('project-ad-budget-form',{attrs:{"projectAdBudget":_vm.projectAdBudget,"type":"create"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }